<template>
    <div>
        <el-row>
            <el-col :span="5"><div class="grid-content"></div></el-col>
            <el-col :span="14">
                <div class="title">
                    <h1>视觉识别与IP设计</h1>
                </div>
                <div class="picture">
                    <img src="../assets/project10_0.jpg.webp">
                    <img src="../assets/project10_1.png.webp">
                    <img src="../assets/project10_2.jpg.webp">
                    <img src="../assets/project10_3.jpg.webp">
                    <img src="../assets/project10_4.jpg.webp">
                    <img src="../assets/project10_1.jpg.webp">
                    <img src="../assets/project10_5.jpg.webp">
                    <img src="../assets/project10_6.jpg.webp">
                    <img src="../assets/project10_7.jpg.webp">
                    <img src="../assets/project10_8.jpg.webp">
                    <img src="../assets/project10_9.jpg.webp">
                    <img src="../assets/project10_12.jpg.webp">
                    <img src="../assets/project10_10.jpg.webp">
                    <img src="../assets/project10_13.jpg.webp">
                    <img src="../assets/project10_11.jpg.webp">

                </div>
            </el-col>
            <el-col :span="5"><div class="grid-content"></div></el-col>
        </el-row>

    </div>
</template>

<script>
    export default {
        name: "Project7Zh"
    }
</script>

<style scoped>
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>